import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Master from './components/layouts/Master';
import Home from './pages/Home';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import Products from './pages/Products';
import CreateProduct from './pages/Products/CreateProduct';
import EditProduct from './pages/Products/EditProduct';
import ProductsLayout from './pages/Products/ProductsLayout';
import Users from './pages/Users';
import CreateUser from './pages/Users/CreateUser';
import EditUser from './pages/Users/EditUser';
import UsersLayout from './pages/Users/UsersLayout';

function App() {
	return (
		<Router>
			<Routes>
				<Route path='/' element={<Master />}>
					<Route index element={<Home />} />
					<Route path='/users' element={<UsersLayout />}>
						<Route index element={<Users />} />
						<Route path='create' element={<CreateUser />} />
						<Route path=':userId' element={<EditUser />} />
					</Route>
					<Route path='/products' element={<ProductsLayout />}>
						<Route index element={<Products />} />
						<Route path='create' element={<CreateProduct />} />
						<Route path=':productId' element={<EditProduct />} />
					</Route>
				</Route>
				<Route path='/login' element={<Login />} />
				<Route path='*' element={<NotFound />} />
			</Routes>
		</Router>
	);
}

export default App;
